import { useState } from "react";
import { createRole } from "../../services/accessControl.api";
import { useSelector } from "react-redux";


export default function CreateRoleModal({
 roleId,
  maxLevel,
  onClose,
  onCreated
}) {

const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
  const [roleKey, setRoleKey] = useState("");
  const [scopeType, setScopeType] = useState("batch");
  const [level, setLevel] = useState(10);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async () => {

    if (!roleKey || !level) {
      setError("All fields required");
      return;
    }

    try {

      setLoading(true);
      setError("");

      const newRole = await createRole({
        roleId,
        roleKey,
        scopeType,AppToken,
       
        level: Number(level)
      });

      onCreated(newRole);
      onClose();

    } catch (err) {

      console.error(err);
      setError(
        err.response?.data?.error ||
        "Failed to create role"
      );

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="crm-overlay">

      <div className="crm-modal">

        <h3>Create Role</h3>

        {error && (
          <p className="crm-error">{error}</p>
        )}

        <div className="crm-field">
          <label>Role Name</label>
          <input
            value={roleKey}
            onChange={e =>
              setRoleKey(
                e.target.value
                  .toLowerCase()
                  .replace(/\s+/g, "_")
              )
            }
          />
        </div>

        <div className="crm-field">
          <label>Scope</label>
          <select
            value={scopeType}
            onChange={e => setScopeType(e.target.value)}
          >
            <option value="app">App</option>
            <option value="batch">Batch</option>
          </select>
        </div>

        <div className="crm-field">
          <label>Level (Max {maxLevel - 1})</label>
          <input
            type="number"
            value={level}
            onChange={e => setLevel(e.target.value)}
          />
        </div>

        <div className="crm-actions">
          <button onClick={onClose}>Cancel</button>
          <button
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Creating..." : "Create"}
          </button>
        </div>

      </div>
      <style>{`.crm-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}

.crm-modal {
  background: white;
  padding: 20px;
  width: 350px;
  border-radius: 6px;
}

.crm-field {
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
}

.crm-field input,
.crm-field select {
  padding: 6px;
  margin-top: 4px;
}

.crm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.crm-error {
  color: red;
  font-size: 13px;
}`}</style>
    </div>
  );
}